import { render } from "./DetailRdex.view.vue?vue&type=template&id=6f66464a"
import script from "./DetailRdex.view.vue?vue&type=script&lang=js"
export * from "./DetailRdex.view.vue?vue&type=script&lang=js"

import "./DetailRdex.view.vue?vue&type=style&index=0&id=6f66464a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__